import React, { PureComponent } from 'react';

export default class extends PureComponent {
  render = (): React.ReactElement => {
    return (
      <svg
        width="19"
        height="25"
        viewBox="0 0 19 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.96053 24.5408L0.25 18.9115V0.43462L8.96053 5.50095V24.5408Z"
          fill="#D7CE00"
          stroke="#C6BD00"
          strokeWidth="0.5"
        />
        <path
          d="M9.51775 24.5408L18.2283 18.9115V0.43462L9.51775 5.50095V24.5408Z"
          fill="#00BA27"
          stroke="#04A926"
          strokeWidth="0.5"
        />
      </svg>
    );
  };
}
